// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes shake {
  0% {
    transform: rotateZ(0);
  }
  10% {
    transform: rotateZ(-30deg);
  }
  20% {
    transform: rotateZ(15deg);
  }
  30% {
    transform: rotateZ(-10deg);
  }
  40% {
    transform: rotateZ(7.5deg);
  }
  50% {
    transform: rotateZ(-6deg);
  }
  60% {
    transform: rotateZ(5deg);
  }
  70% {
    transform: rotateZ(-4.28571deg);
  }
  80% {
    transform: rotateZ(3.75deg);
  }
  90% {
    transform: rotateZ(-3.33333deg);
  }
  100% {
    transform: rotateZ(0);
  }
}

.wrap {
  display: inline-block;
  /* float: right; */
  /* padding: 5px; */
}

span[class*='icon'] {
  display: inline-block;
}

.container {
  position: relative;
  perspective: 100px;
  transform-style: preserve-3d;
}

#phonewrap {
  /* position: absolute;
  right: 10px; */
  float: right;
  margin-right: 1rem;
  /* position: absolute; */
  /* right: 8px; */
}

.icon {
  /* margin-left: 2rem; */
  /* float: right; */
}

#phonewrap:hover {
  display: inline-block;
  cursor: pointer;
  animation: shake 1200ms;
}

#jsoncode:hover {
  cursor: pointer;
  animation: shake 1200ms;
}

.userCard #phonewrap {
  float: right;
  margin-right: -90%;
}
`, "",{"version":3,"sources":["webpack://./src/modules/private/pages/editIcon.css"],"names":[],"mappings":"AAAA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;gBACc;EACd,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["@keyframes shake {\r\n  0% {\r\n    transform: rotateZ(0);\r\n  }\r\n  10% {\r\n    transform: rotateZ(-30deg);\r\n  }\r\n  20% {\r\n    transform: rotateZ(15deg);\r\n  }\r\n  30% {\r\n    transform: rotateZ(-10deg);\r\n  }\r\n  40% {\r\n    transform: rotateZ(7.5deg);\r\n  }\r\n  50% {\r\n    transform: rotateZ(-6deg);\r\n  }\r\n  60% {\r\n    transform: rotateZ(5deg);\r\n  }\r\n  70% {\r\n    transform: rotateZ(-4.28571deg);\r\n  }\r\n  80% {\r\n    transform: rotateZ(3.75deg);\r\n  }\r\n  90% {\r\n    transform: rotateZ(-3.33333deg);\r\n  }\r\n  100% {\r\n    transform: rotateZ(0);\r\n  }\r\n}\r\n\r\n.wrap {\r\n  display: inline-block;\r\n  /* float: right; */\r\n  /* padding: 5px; */\r\n}\r\n\r\nspan[class*='icon'] {\r\n  display: inline-block;\r\n}\r\n\r\n.container {\r\n  position: relative;\r\n  perspective: 100px;\r\n  transform-style: preserve-3d;\r\n}\r\n\r\n#phonewrap {\r\n  /* position: absolute;\r\n  right: 10px; */\r\n  float: right;\r\n  margin-right: 1rem;\r\n  /* position: absolute; */\r\n  /* right: 8px; */\r\n}\r\n\r\n.icon {\r\n  /* margin-left: 2rem; */\r\n  /* float: right; */\r\n}\r\n\r\n#phonewrap:hover {\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  animation: shake 1200ms;\r\n}\r\n\r\n#jsoncode:hover {\r\n  cursor: pointer;\r\n  animation: shake 1200ms;\r\n}\r\n\r\n.userCard #phonewrap {\r\n  float: right;\r\n  margin-right: -90%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
